import React from "react";
import { Routes, Route } from "react-router-dom";
import AuthenticationGate from "./AthenticationGate";
/*Bank */
import Overview from "../Components/Overview/Overview";
import InternalAlerts from "../Components/Alerts/InternalAlerts/InternalAlerts";
import Notifications from "../Components/Alerts/Notifications/FollowingOnNotifications/Notifications";
import Customers from "../Components/Alerts/Notifications/Customers/Customers";
import MatchingRules from "../Components/Mathcing/MatchingRules/MatchingRules";
import Reports from "../Components/Reporting/Reports";
import License from "../Components/License/License";
import CustomizeModules from "../Components/License/CustomizeModules";
import SearchArchive from "../Components/AdminTool/SearchArchive/SearchArchive";
import { BankSettings } from "../Components/AdminTool/BankSettings/BankSettings";
import ReportDetails from "../Components/Reporting/ReportDetails";
import { Alerts } from "../Components/AdminTool/Alerts & Notifications/Alerts&Notification";
import FollowingAlertsView from "../Components/Alerts/FollowingOnAlerts/FollowingAlertsView";
/*Admin */
import AdminLicense from "../Components/Admin/License/License";
import SwiftDayView from "../Components/Swift/SwiftDay/SwiftDayView";
import SwiftMessagesView from "../Components/Swift/SwiftMessages/SwiftMessagesView";
import Dashboard from "../Components/Admin/Dashboard/Dashboard";
import CustomerGroups from "../Components/Alerts/CustomersGroups/CustomerGroups";
import MatchingDay from "../Components/Mathcing/MatchingDay/MatchingDay";
import MatchingDetails from "../Components/Mathcing/MatchingRules/MatchingDetails";
import ChangeRequests from "../Components/Admin/ChangeRequests/ChangeRequests";

const AllRoutes = () => {
  return (
    <Routes>
      <Route path="/login" element={<Overview />} />
      {/*Bank */}
      <Route
        path="/"
        element={
          <AuthenticationGate>
            <Overview />
          </AuthenticationGate>
        }
      />
      <Route
        path="/swift-day"
        element={
          <AuthenticationGate>
            <SwiftDayView />
          </AuthenticationGate>
        }
      />
      <Route
        path="/swift-search"
        element={
          <AuthenticationGate>
            <SwiftMessagesView />
          </AuthenticationGate>
        }
      />

      <Route
        path="/internal-alerts"
        element={
          <AuthenticationGate>
            <FollowingAlertsView />
          </AuthenticationGate>
        }
      />
      <Route
        path="/alerts-settings"
        element={
          <AuthenticationGate>
            <InternalAlerts />
          </AuthenticationGate>
        }
      />

      <Route
        path="/customers-list"
        element={
          <AuthenticationGate>
            <Customers />
          </AuthenticationGate>
        }
      />
      <Route
        path="/customers-groups"
        element={
          <AuthenticationGate>
            <CustomerGroups />
          </AuthenticationGate>
        }
      />
      <Route
        path="/generated-notifications"
        element={
          <AuthenticationGate>
            <Notifications />
          </AuthenticationGate>
        }
      />

      <Route
        path="/matching-rules"
        element={
          <AuthenticationGate>
            <MatchingRules />
          </AuthenticationGate>
        }
      />
      <Route
        path="/rules/:matchingId"
        element={
          <AuthenticationGate>
            <MatchingDetails />
          </AuthenticationGate>
        }
      />
      <Route
        path="/matching-day"
        element={
          <AuthenticationGate>
            <MatchingDay />
          </AuthenticationGate>
        }
      />

      <Route
        path="/reports"
        element={
          <AuthenticationGate>
            <Reports />
          </AuthenticationGate>
        }
      />
      <Route
        path="/reports/:type/:reportId"
        element={
          <AuthenticationGate>
            <ReportDetails />
          </AuthenticationGate>
        }
      />

      <Route
        path="/license"
        element={
          <AuthenticationGate>
            <License />
          </AuthenticationGate>
        }
      />

      <Route
        path="/license/modules"
        element={
          <AuthenticationGate>
            <CustomizeModules />
          </AuthenticationGate>
        }
      />

      <Route
        path="/admin-tool/bank-settings"
        element={
          <AuthenticationGate>
            <BankSettings />
          </AuthenticationGate>
        }
      />
      <Route
        path="/admin-tool/alerts-notifications"
        element={
          <AuthenticationGate>
            <Alerts />
          </AuthenticationGate>
        }
      />
      <Route
        path="/admin-tool/search-archive"
        element={
          <AuthenticationGate>
            <SearchArchive />
          </AuthenticationGate>
        }
      />

      {/* <Route
        path="/user-management/users"
        element={
          <AuthenticationGate>
            <License />
          </AuthenticationGate>
        }
      /> */}

      {/*Admin */}
      <Route
        path="/admin"
        element={
          <AuthenticationGate>
            <Dashboard />
          </AuthenticationGate>
        }
      />
      <Route
        path="/admin/license"
        element={
          <AuthenticationGate>
            <AdminLicense />
          </AuthenticationGate>
        }
      />

      <Route
        path="/admin/change-requests"
        element={
          <AuthenticationGate>
            <ChangeRequests />
          </AuthenticationGate>
        }
      />
    </Routes>
  );
};

export default AllRoutes;
